import { useEffect } from "react";
import { useLocation } from 'react-router-dom';

const PageScrollTop = ({ children }) => {
    const location = useLocation();
    
    useEffect(() => {
        if (typeof window === "undefined") return;

        if (location.hash) {
            const elementId = location.hash.replace("#", "");
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView();
                return;
            }
        }

        window.scrollTo(0, 0);
    }, [location.pathname, location.hash]);
    
    return children;
};

export default PageScrollTop;
